document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.splide').forEach(function(el) {
        var slideCount = el.querySelectorAll('.splide__slide').length;
        var dataConfig = {};
        try { dataConfig = JSON.parse(el.getAttribute('data-splide') || '{}'); } catch(e) {}
        var perPage = (dataConfig && dataConfig.perPage) || 3;

        // Check if slides overflow at any breakpoint (desktop or mobile)
        var minPerPage = perPage;
        if (dataConfig.breakpoints) {
            Object.keys(dataConfig.breakpoints).forEach(function(bp) {
                var bpPerPage = dataConfig.breakpoints[bp].perPage;
                if (bpPerPage && bpPerPage < minPerPage) minPerPage = bpPerPage;
            });
        }
        var hasDesktopOverflow = slideCount > perPage;

        var splide = new Splide(el, {
            type: hasDesktopOverflow ? 'loop' : 'slide',
            arrows: hasDesktopOverflow && (dataConfig.arrows !== false),
            pagination: hasDesktopOverflow ? (dataConfig.pagination !== false) : false
        });

        // Pause autoplay while a video slide is visible and playing
        splide.on('mounted moved', function() {
            var activeSlide = el.querySelector('.splide__slide.is-active .banner-carousel__slide--video');
            if (!activeSlide) return;
            var video = activeSlide.querySelector('video');
            if (video) {
                video.play().then(function() {
                    activeSlide.classList.add('is-video-playing');
                }).catch(function() {});
            }
        });

        splide.mount();

        // Fix: Splide adds invalid ARIA roles/attributes
        function fixSplideA11y() {
            // Remove invalid roles from slides
            el.querySelectorAll('.splide__slide[role]').forEach(function(slide) {
                slide.removeAttribute('role');
            });
            // Fix pagination — remove invalid tablist/tab/aria-selected
            el.querySelectorAll('.splide__pagination[role]').forEach(function(nav) {
                nav.removeAttribute('role');
            });
            el.querySelectorAll('.splide__pagination__page').forEach(function(btn) {
                btn.removeAttribute('role');
                btn.removeAttribute('aria-selected');
            });
            // Remove duplicate landmark if parent is already a landmark (section with aria-label)
            if (el.closest('section[aria-label]')) {
                el.removeAttribute('role');
                el.removeAttribute('aria-roledescription');
            }
        }
        fixSplideA11y();
        splide.on('moved', fixSplideA11y);
    });

    // Fade out poster when video starts playing
    document.querySelectorAll('.banner-carousel__slide--video video').forEach(function(video) {
        video.addEventListener('playing', function() {
            var slide = video.closest('.banner-carousel__slide--video');
            if (slide) slide.classList.add('is-video-playing');
        });
    });

    // Header basket preview — flyout dropdown on hover
    (function() {
        var SPEKTRIX_API = 'https://tickets.chelmsfordtheatre.co.uk/chelmsfordtheatre/api/v3';
        var wrapper = document.getElementById('header-basket');
        var badge = document.getElementById('header-basket-badge');
        var itemsEl = document.getElementById('header-basket-items');
        var footerEl = document.getElementById('header-basket-footer');
        var totalEl = document.getElementById('header-basket-total');
        if (!wrapper || !badge || !itemsEl) return;

        var cachedBasket = null;
        var lastFetch = 0;
        var fetching = false;
        var CACHE_MS = 30000; // refresh every 30s

        function formatPrice(amount) {
            return '\u00A3' + parseFloat(amount || 0).toFixed(2);
        }

        function formatDate(dateStr) {
            if (!dateStr) return '';
            try {
                var d = new Date(dateStr);
                return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
            } catch (e) { return ''; }
        }

        function escapeHtml(str) {
            var d = document.createElement('div');
            d.textContent = str || '';
            return d.innerHTML;
        }

        function renderBadge(basket) {
            var count = (basket.tickets || []).length +
                        (basket.donations || []).length +
                        (basket.merchandiseItems || []).length +
                        (basket.membershipSubscriptions || []).length;
            badge.textContent = count > 0 ? count : '';
            badge.style.display = count > 0 ? 'flex' : 'none';
        }

        // Cache for event/instance names from Umbraco
        var eventNames = {};
        var instanceDates = {};

        function fetchDetails(tickets) {
            var eIds = [];
            var iIds = [];
            tickets.forEach(function(t) {
                if (t.event && t.event.id && !eventNames[t.event.id]) eIds.push(t.event.id);
                if (t.instance && t.instance.id && !instanceDates[t.instance.id]) iIds.push(t.instance.id);
            });
            if (eIds.length === 0 && iIds.length === 0) return Promise.resolve();

            return fetch('/events/lookup?eventIds=' + encodeURIComponent(eIds.join(',')) +
                         '&instanceIds=' + encodeURIComponent(iIds.join(',')))
                .then(function(res) { return res.ok ? res.json() : null; })
                .then(function(data) {
                    if (!data) return;
                    if (data.events) {
                        Object.keys(data.events).forEach(function(id) {
                            eventNames[id] = data.events[id].name || 'Event';
                        });
                    }
                    if (data.instances) {
                        Object.keys(data.instances).forEach(function(id) {
                            instanceDates[id] = data.instances[id].start || '';
                        });
                    }
                })
                .catch(function() { });
        }

        function buildFlyoutHtml(tickets, donations, memberships, merchandise) {
            var html = '';

            // Group tickets by event+instance
            var groups = {};
            var groupOrder = [];
            tickets.forEach(function(t) {
                var key = (t.event ? t.event.id : '') + '|' + (t.instance ? t.instance.id : '');
                if (!groups[key]) {
                    groups[key] = { tickets: [], sample: t };
                    groupOrder.push(key);
                }
                groups[key].tickets.push(t);
            });

            groupOrder.forEach(function(key) {
                var g = groups[key];
                var s = g.sample;
                var eventId = s.event ? s.event.id : '';
                var instanceId = s.instance ? s.instance.id : '';
                var eventName = eventNames[eventId] || (s.event && s.event.description) || 'Event';
                var date = instanceDates[instanceId] ? formatDate(instanceDates[instanceId]) : '';
                var count = g.tickets.length;
                var lineTotal = 0;
                g.tickets.forEach(function(t) { lineTotal += parseFloat(t.total || t.price || 0); });

                html += '<div class="basket-flyout__item">' +
                    '<div class="basket-flyout__item-info">' +
                        '<span class="basket-flyout__item-name">' + escapeHtml(eventName) + '</span>' +
                        (date ? '<span class="basket-flyout__item-date"><i class="fa-regular fa-calendar" aria-hidden="true"></i>' + escapeHtml(date) + '</span>' : '') +
                    '</div>' +
                    '<div class="basket-flyout__item-meta">' +
                        '<span class="basket-flyout__item-qty">&times;' + count + '</span>' +
                        '<span class="basket-flyout__item-price">' + formatPrice(lineTotal) + '</span>' +
                    '</div>' +
                '</div>';
            });

            // Membership subscriptions
            memberships.forEach(function(sub) {
                var name = sub.membership ? sub.membership.name : 'Membership';
                var price = sub.price != null ? sub.price : (sub.total || 0);
                html += '<div class="basket-flyout__item">' +
                    '<div class="basket-flyout__item-info">' +
                        '<span class="basket-flyout__item-name">' + escapeHtml(name) + '</span>' +
                        '<span class="basket-flyout__item-date"><i class="fa-solid fa-id-card" aria-hidden="true"></i>Membership</span>' +
                    '</div>' +
                    '<div class="basket-flyout__item-meta">' +
                        '<span class="basket-flyout__item-price">' + formatPrice(price) + '</span>' +
                    '</div>' +
                '</div>';
            });

            // Merchandise
            merchandise.forEach(function(m) {
                var name = m.description || m.name || 'Merchandise';
                var price = m.price != null ? m.price : (m.total || 0);
                html += '<div class="basket-flyout__item">' +
                    '<div class="basket-flyout__item-info">' +
                        '<span class="basket-flyout__item-name">' + escapeHtml(name) + '</span>' +
                    '</div>' +
                    '<div class="basket-flyout__item-meta">' +
                        '<span class="basket-flyout__item-price">' + formatPrice(price) + '</span>' +
                    '</div>' +
                '</div>';
            });

            // Donations
            donations.forEach(function(d) {
                html += '<div class="basket-flyout__item">' +
                    '<div class="basket-flyout__item-info">' +
                        '<span class="basket-flyout__item-name">Donation</span>' +
                    '</div>' +
                    '<div class="basket-flyout__item-meta">' +
                        '<span class="basket-flyout__item-price">' + formatPrice(d.amount || 0) + '</span>' +
                    '</div>' +
                '</div>';
            });

            return html;
        }

        function renderFlyout(basket) {
            var tickets = basket.tickets || [];
            var donations = basket.donations || [];
            var memberships = basket.membershipSubscriptions || [];
            var merchandise = basket.merchandiseItems || [];
            var total = basket.total || 0;
            var hasItems = tickets.length > 0 || donations.length > 0 || memberships.length > 0 || merchandise.length > 0;

            if (!hasItems) {
                itemsEl.innerHTML = '<p class="basket-flyout__empty"><i class="fa-solid fa-basket-shopping"></i>Your basket is empty</p>';
                footerEl.style.display = 'none';
                return;
            }

            // Fetch event names first, then render
            totalEl.textContent = formatPrice(total);
            footerEl.style.display = '';

            if (tickets.length > 0) {
                fetchDetails(tickets).then(function() {
                    itemsEl.innerHTML = buildFlyoutHtml(tickets, donations, memberships, merchandise);
                }).catch(function() {
                    itemsEl.innerHTML = buildFlyoutHtml(tickets, donations, memberships, merchandise);
                });
            } else {
                itemsEl.innerHTML = buildFlyoutHtml(tickets, donations, memberships, merchandise);
            }
        }

        function fetchBasket() {
            if (fetching) return;
            var now = Date.now();
            if (cachedBasket && (now - lastFetch) < CACHE_MS) {
                renderFlyout(cachedBasket);
                return;
            }
            fetching = true;
            itemsEl.innerHTML = '<p class="basket-flyout__loading"><i class="fa-solid fa-spinner fa-spin"></i>Loading basket...</p>';

            fetch(SPEKTRIX_API + '/basket', { credentials: 'include', headers: { 'Accept': 'application/json' } })
                .then(function(res) { return res.ok ? res.json() : null; })
                .then(function(data) {
                    fetching = false;
                    if (!data) { itemsEl.innerHTML = '<p class="basket-flyout__empty">Could not load basket</p>'; return; }
                    cachedBasket = data;
                    lastFetch = Date.now();
                    renderBadge(data);
                    renderFlyout(data);
                })
                .catch(function() {
                    fetching = false;
                    itemsEl.innerHTML = '<p class="basket-flyout__empty">Could not load basket</p>';
                });
        }

        var isBookingPage = /^\/booking\//i.test(window.location.pathname);

        if (!isBookingPage) {
            // Fetch on first load for badge count + flyout on hover
            fetchBasket();
            wrapper.addEventListener('mouseenter', fetchBasket);
        }
        // On booking pages, badge is updated by the page's own basket JS (Basket.cshtml / Checkout.cshtml)
    })();

    // Sticky header — add solid background on scroll
    // If header already has --scrolled (forced by page), skip scroll toggling
    var siteHeader = document.querySelector('.site-header');
    if (siteHeader && !siteHeader.classList.contains('site-header--scrolled')) {
        var scrollThreshold = 50;
        function onHeaderScroll() {
            if (window.scrollY > scrollThreshold) {
                siteHeader.classList.add('site-header--scrolled');
            } else {
                siteHeader.classList.remove('site-header--scrolled');
            }
        }
        window.addEventListener('scroll', onHeaderScroll, { passive: true });
        onHeaderScroll();
    }

    // Nav dropdowns — click to open, mouse-leave with delay to close
    (function() {
        var dropdownItems = document.querySelectorAll('.site-nav__item--has-dropdown');
        var closeTimers = {};

        function closeAll(except) {
            dropdownItems.forEach(function(item, i) {
                if (item !== except) {
                    item.classList.remove('is-open');
                    var link = item.querySelector('.site-nav__link');
                    if (link) link.setAttribute('aria-expanded', 'false');
                }
            });
        }

        dropdownItems.forEach(function(item, index) {
            var link = item.querySelector('.site-nav__link');

            // Click the link text to toggle dropdown (prevent navigation)
            link.addEventListener('click', function(e) {
                e.preventDefault();
                var wasOpen = item.classList.contains('is-open');
                closeAll();
                if (!wasOpen) {
                    item.classList.add('is-open');
                    link.setAttribute('aria-expanded', 'true');
                }
                clearTimeout(closeTimers[index]);
            });

            // Mouse-leave with 300ms grace period
            item.addEventListener('mouseleave', function() {
                closeTimers[index] = setTimeout(function() {
                    item.classList.remove('is-open');
                    if (link) link.setAttribute('aria-expanded', 'false');
                }, 300);
            });

            // Cancel close if mouse re-enters
            item.addEventListener('mouseenter', function() {
                clearTimeout(closeTimers[index]);
            });
        });

        // Click outside closes all dropdowns
        document.addEventListener('click', function(e) {
            if (!e.target.closest('.site-nav__item--has-dropdown')) {
                closeAll();
            }
        });

        // ESC closes all dropdowns
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                closeAll();
            }
        });
    })();

    // Search panel toggle
    var searchToggle = document.getElementById('site-search-toggle');
    var searchPanel = document.getElementById('site-search-panel');
    if (searchToggle && searchPanel) {
        searchToggle.addEventListener('click', function(e) {
            e.preventDefault();
            searchPanel.classList.toggle('site-search--open');
            if (searchPanel.classList.contains('site-search--open')) {
                document.getElementById('site-search-input').focus();
            }
        });
    }

    // Mega menu toggle
    var menuBtn = document.querySelector('.site-header__menu-btn');
    var megaMenu = document.getElementById('mega-menu');
    var megaMenuClose = megaMenu ? megaMenu.querySelector('.mega-menu__close') : null;

    function setCircleOrigin() {
        // Position the clip-path circle origin at the centre of the hamburger button
        var rect = menuBtn.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        megaMenu.style.setProperty('--circle-x', cx + 'px');
        megaMenu.style.setProperty('--circle-y', cy + 'px');
    }

    function closeMegaMenu() {
        setCircleOrigin();
        menuBtn.classList.remove('is-active');
        menuBtn.querySelector('.hamburger').classList.remove('is-active');
        megaMenu.classList.remove('mega-menu--open');
        megaMenu.setAttribute('aria-hidden', 'true');
        menuBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('mega-menu-active');
    }

    if (menuBtn && megaMenu) {
        menuBtn.addEventListener('click', function() {
            setCircleOrigin();
            var isActive = menuBtn.classList.toggle('is-active');
            menuBtn.querySelector('.hamburger').classList.toggle('is-active');
            megaMenu.classList.toggle('mega-menu--open');
            megaMenu.setAttribute('aria-hidden', !isActive);
            menuBtn.setAttribute('aria-expanded', isActive);
            document.body.classList.toggle('mega-menu-active', isActive);

            if (isActive && megaMenuClose) {
                setTimeout(function() { megaMenuClose.focus(); }, 100);
            }
        });

        if (megaMenuClose) {
            megaMenuClose.addEventListener('click', function() {
                closeMegaMenu();
                menuBtn.focus();
            });
        }

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && megaMenu.classList.contains('mega-menu--open')) {
                closeMegaMenu();
                menuBtn.focus();
            }
        });

        // Focus trap inside mega menu
        megaMenu.addEventListener('keydown', function(e) {
            if (e.key !== 'Tab') return;
            if (!megaMenu.classList.contains('mega-menu--open')) return;

            var focusable = megaMenu.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (!focusable.length) return;

            var first = focusable[0];
            var last = focusable[focusable.length - 1];

            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        });
    }


    // Mega menu accordion navigation
    (function() {
        function openAccordion(accordion) {
            var panel = accordion.querySelector('.mega-menu__accordion-panel');
            var trigger = accordion.querySelector('.mega-menu__accordion-trigger');
            accordion.classList.add('is-open');
            if (trigger) trigger.setAttribute('aria-expanded', 'true');
            if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
        }

        function closeAccordion(accordion) {
            var panel = accordion.querySelector('.mega-menu__accordion-panel');
            var trigger = accordion.querySelector('.mega-menu__accordion-trigger');
            accordion.classList.remove('is-open');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
            if (panel) panel.style.maxHeight = '0px';
        }

        var triggers = document.querySelectorAll('.mega-menu__accordion-trigger');
        triggers.forEach(function(btn) {
            btn.addEventListener('click', function() {
                var accordion = btn.closest('.mega-menu__accordion');
                var wasOpen = accordion.classList.contains('is-open');

                // Close all accordions first (single-open)
                document.querySelectorAll('.mega-menu__accordion').forEach(function(acc) {
                    closeAccordion(acc);
                });

                if (!wasOpen) {
                    openAccordion(accordion);
                }
            });
        });

        // Populate mega menu date shortcuts
        (function() {
            var datesList = document.getElementById('mega-menu-dates');
            if (!datesList) return;

            function fmt(date) {
                return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
            }
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            var tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
            var dayOfWeek = today.getDay() || 7;
            var thisSatStart = new Date(today); thisSatStart.setDate(today.getDate() + (6 - dayOfWeek));
            var thisSunEnd = new Date(thisSatStart); thisSunEnd.setDate(thisSatStart.getDate() + 1);
            var thisWeekEnd = new Date(today); thisWeekEnd.setDate(today.getDate() + (7 - dayOfWeek));

            var shortcuts = [
                { label: 'Today', from: today, to: today },
                { label: 'Tomorrow', from: tomorrow, to: tomorrow },
                { label: 'This Weekend', from: thisSatStart, to: thisSunEnd },
                { label: 'This Week', from: today, to: thisWeekEnd }
            ];

            shortcuts.forEach(function(s) {
                var li = document.createElement('li');
                li.innerHTML = '<a href="/events?from=' + fmt(s.from) + '&to=' + fmt(s.to) + '" class="mega-menu__accordion-child">' + s.label + '</a>';
                datesList.appendChild(li);
            });
        })();

        // Right-side collapsible group toggles
        var rightToggles = document.querySelectorAll('.mega-menu__right-toggle');
        rightToggles.forEach(function(btn) {
            btn.addEventListener('click', function() {
                var group = btn.closest('.mega-menu__right-group');
                group.classList.toggle('is-open');
                btn.setAttribute('aria-expanded', group.classList.contains('is-open'));
            });
        });

        // Open default accordion + reset when menu opens/closes
        if (megaMenu) {
            var observer = new MutationObserver(function() {
                if (megaMenu.classList.contains('mega-menu--open')) {
                    // No auto-open — let user choose which section to expand
                } else {
                    // Reset all when closing
                    document.querySelectorAll('.mega-menu__accordion').forEach(function(acc) {
                        closeAccordion(acc);
                    });
                    document.querySelectorAll('.mega-menu__right-group').forEach(function(g) {
                        g.classList.remove('is-open');
                        var t = g.querySelector('.mega-menu__right-toggle');
                        if (t) t.setAttribute('aria-expanded', 'false');
                    });
                }
            });
            observer.observe(megaMenu, { attributes: true, attributeFilter: ['class'] });
        }
    })();

    // Nav dropdown — populate months and date shortcuts
    (function() {
        var monthNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        var monthsList = document.getElementById('nav-dropdown-months');
        var datesList = document.getElementById('nav-dropdown-dates');
        if (!monthsList || !datesList) return;

        // Months — build links for the next 12 months
        var now = new Date();
        for (var i = 0; i < 12; i++) {
            var d = new Date(now.getFullYear(), now.getMonth() + i, 1);
            var y = d.getFullYear();
            var m = d.getMonth();
            var from = y + '-' + String(m + 1).padStart(2, '0') + '-01';
            var lastDay = new Date(y, m + 1, 0).getDate();
            var to = y + '-' + String(m + 1).padStart(2, '0') + '-' + String(lastDay).padStart(2, '0');
            var li = document.createElement('li');
            li.innerHTML = '<a href="/events?from=' + from + '&to=' + to + '" class="nav-dropdown__link">' + monthNames[m] + '</a>';
            monthsList.appendChild(li);
        }

        // Date shortcuts
        function fmt(date) {
            return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
        }
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
        var dayOfWeek = today.getDay() || 7; // Mon=1..Sun=7
        var thisSatStart = new Date(today); thisSatStart.setDate(today.getDate() + (6 - dayOfWeek));
        var thisSunEnd = new Date(thisSatStart); thisSunEnd.setDate(thisSatStart.getDate() + 1);
        var thisWeekEnd = new Date(today); thisWeekEnd.setDate(today.getDate() + (7 - dayOfWeek));
        var nextWeekStart = new Date(thisWeekEnd); nextWeekStart.setDate(thisWeekEnd.getDate() + 1);
        var nextWeekEnd = new Date(nextWeekStart); nextWeekEnd.setDate(nextWeekStart.getDate() + 6);
        var nextSatStart = new Date(nextWeekStart); nextSatStart.setDate(nextWeekStart.getDate() + (6 - (nextWeekStart.getDay() || 7)));
        var nextSunEnd = new Date(nextSatStart); nextSunEnd.setDate(nextSatStart.getDate() + 1);
        var nextMonthStart = new Date(today.getFullYear(), today.getMonth() + 1, 1);
        var nextMonthEnd = new Date(today.getFullYear(), today.getMonth() + 2, 0);

        var dateShortcuts = [
            { label: 'Today', from: today, to: today },
            { label: 'Tomorrow', from: tomorrow, to: tomorrow },
            { label: 'This Weekend', from: thisSatStart, to: thisSunEnd },
            { label: 'This Week', from: today, to: thisWeekEnd },
            { label: 'Next Week', from: nextWeekStart, to: nextWeekEnd },
            { label: 'Next Weekend', from: nextSatStart, to: nextSunEnd },
            { label: 'Next Month', from: nextMonthStart, to: nextMonthEnd }
        ];

        dateShortcuts.forEach(function(s) {
            var li = document.createElement('li');
            li.innerHTML = '<a href="/events?from=' + fmt(s.from) + '&to=' + fmt(s.to) + '" class="nav-dropdown__link">' + s.label + '</a>';
            datesList.appendChild(li);
        });
    })();

    // Nav dropdown — tab switching (What's On tabbed layout)
    (function() {
        var tabs = document.querySelectorAll('.nav-dropdown__tab');
        var panels = document.querySelectorAll('.nav-dropdown__panel');
        if (!tabs.length) return;

        tabs.forEach(function(tab) {
            tab.addEventListener('click', function() {
                var target = tab.getAttribute('data-tab');
                tabs.forEach(function(t) { t.classList.remove('is-active'); });
                panels.forEach(function(p) { p.classList.remove('is-active'); });
                tab.classList.add('is-active');
                var panel = document.querySelector('.nav-dropdown__panel[data-panel="' + target + '"]');
                if (panel) panel.classList.add('is-active');
            });
        });
    })();

    // Accordions
    document.querySelectorAll('.accordian__header').forEach(function(header) {
        header.addEventListener('click', function() {
            var accordian = header.closest('.accordian');
            var content = accordian.querySelector('.accordian__content');
            var isActive = accordian.classList.toggle('active');
            header.setAttribute('aria-expanded', isActive);
            content.style.display = isActive ? 'block' : 'none';
        });

        header.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                header.click();
            }
        });
    });

    // Tabbed content
    document.querySelectorAll('.tabbed-content__tab').forEach(function(tab) {
        tab.addEventListener('click', function() {
            var tabGroup = tab.closest('.tabbed-content');
            tabGroup.querySelectorAll('.tabbed-content__tab').forEach(function(t) {
                t.classList.remove('tabbed-content__tab--active');
                t.setAttribute('aria-selected', 'false');
                t.setAttribute('tabindex', '-1');
            });
            tabGroup.querySelectorAll('.tabbed-content__panel').forEach(function(p) {
                p.classList.remove('tabbed-content__panel--active');
                p.hidden = true;
            });
            tab.classList.add('tabbed-content__tab--active');
            tab.setAttribute('aria-selected', 'true');
            tab.setAttribute('tabindex', '0');
            var panelId = tab.getAttribute('aria-controls');
            var panel = document.getElementById(panelId);
            if (panel) {
                panel.classList.add('tabbed-content__panel--active');
                panel.hidden = false;
            }
        });
    });

    // Tab arrow key navigation (WAI-ARIA tabs pattern)
    document.querySelectorAll('.tabbed-content__tabs').forEach(function(tablist) {
        tablist.addEventListener('keydown', function(e) {
            var tabs = Array.from(tablist.querySelectorAll('.tabbed-content__tab'));
            if (!tabs.length) return;

            var currentIndex = tabs.indexOf(document.activeElement);
            if (currentIndex === -1) return;

            var newIndex = -1;
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                e.preventDefault();
                newIndex = (currentIndex + 1) % tabs.length;
            } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                e.preventDefault();
                newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            } else if (e.key === 'Home') {
                e.preventDefault();
                newIndex = 0;
            } else if (e.key === 'End') {
                e.preventDefault();
                newIndex = tabs.length - 1;
            }

            if (newIndex !== -1) {
                tabs[newIndex].focus();
                tabs[newIndex].click();
            }
        });
    });

    // Scroll-reveal — JS adds .reveal--ready (hidden state), then observer adds
    // .reveal--visible on scroll. If JS never runs, blocks stay fully visible.
    (function() {
        var reveals = document.querySelectorAll('.reveal');
        if (!reveals.length) return;

        // No IntersectionObserver — leave blocks visible (no --ready added)
        if (!('IntersectionObserver' in window)) return;

        // Split block headings into word spans for curtain-rise effect.
        // Each word gets wrapped: <span class="word-wrap"><span class="word">text</span></span>
        // The outer span clips overflow; the inner span slides up via CSS transition.
        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!prefersReduced) {
            function splitWords(el) {
                var text = el.textContent.trim();
                if (!text) return;
                el.classList.add('reveal-heading');
                var words = text.split(/\s+/);
                var inner = words.map(function(word) {
                    var safe = word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                    return '<span class="word-wrap"><span class="word">' + safe + '</span></span>';
                }).join('');
                // Wrap all word-spans in a single container so flex gap
                // only applies between ::before/text/::after, not between words
                el.innerHTML = '<span class="reveal-heading__words">' + inner + '</span>';
            }

            // Split block headings + hero titles.
            // Target specific BEM heading classes rather than all h2 inside .reveal,
            // to avoid catching nested content like card titles, dates, etc.
            var headingSelector = [
                '.section-heading__title',
                '.content-block__heading',
                '.card-grid__heading',
                '.text-block__heading',
                '.cta-block__heading',
                '.gallery-block__heading',
                '.person-carousel__heading',
                '.pricing-cards__heading',
                '.category-icons__heading',
                '.partner-logos__heading',
                '.map-block__heading',
                '.donation-block__heading',
                '.form-block__heading',
                '.tabbed-content__heading',
                '.data-table__heading',
                '.membership-block__heading',
                '.gift-voucher-block__heading',
                '.event-detail__tickets-heading',
                '.event-detail__similar-heading',
                '.accordian__header h4',
                '.hero-block__title'
            ].join(', ');
            document.querySelectorAll(headingSelector).forEach(splitWords);

            // Hero titles are above the fold — reveal on page load
            setTimeout(function() {
                document.querySelectorAll('.hero-block__title.reveal-heading').forEach(function(el) {
                    el.classList.add('reveal-heading--visible');
                });
            }, 150);

            // Banner carousel titles — split after Splide has cloned slides
            // so both originals and clones get the word-wrap markup
            setTimeout(function() {
                document.querySelectorAll('.banner-carousel__title').forEach(function(title) {
                    if (title.classList.contains('reveal-heading')) return;
                    splitWords(title);
                    title.classList.add('reveal-heading--visible');
                });
            }, 500);
        }

        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('reveal--visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.05 });

        reveals.forEach(function(el) {
            el.classList.add('reveal--ready');
            observer.observe(el);
        });
    })();

    // Animated slide-up placeholder suggestions for search inputs
    (function() {
        var suggestions = [
            'Try "something fun for the family"',
            'Try "comedy this weekend"',
            'Try "BSL signed performances"',
            'Try "live music in March"',
            'Try "relaxed performances for kids"',
            'Try "drama this month"',
            'Try "what\u2019s on tonight?"',
            'Try "panto tickets"',
            'Try "stand-up comedy"',
            'Try "dance shows this spring"'
        ];

        var SLIDE_INTERVAL = 3000;

        function initSlider(input, startIndex) {
            if (!input || input.value) return;

            var wrapper = input.closest('.search-slider');
            if (!wrapper) return;

            input.setAttribute('placeholder', '');

            var overlay = document.createElement('div');
            overlay.className = 'search-slider__overlay';
            overlay.setAttribute('aria-hidden', 'true');

            var track = document.createElement('div');
            track.className = 'search-slider__track';

            suggestions.forEach(function(s) {
                var item = document.createElement('span');
                item.className = 'search-slider__item';
                item.textContent = s;
                track.appendChild(item);
            });

            overlay.appendChild(track);
            wrapper.appendChild(overlay);

            var currentIndex = startIndex || 0;
            var timer = null;
            var itemHeight = 0;

            function measure() {
                itemHeight = input.offsetHeight;
                var items = track.querySelectorAll('.search-slider__item');
                for (var i = 0; i < items.length; i++) {
                    items[i].style.height = itemHeight + 'px';
                    items[i].style.lineHeight = itemHeight + 'px';
                }
            }

            function setSlide(index, animate) {
                measure();
                if (animate) {
                    track.classList.add('search-slider__track--animating');
                } else {
                    track.classList.remove('search-slider__track--animating');
                }
                track.style.transform = 'translateY(-' + (index * itemHeight) + 'px)';
            }

            setSlide(currentIndex, false);

            function advance() {
                var next = (currentIndex + 1) % suggestions.length;
                setSlide(next, true);
                currentIndex = next;
            }

            function start() {
                if (!timer) timer = setInterval(advance, SLIDE_INTERVAL);
            }

            function stop() {
                if (timer) { clearInterval(timer); timer = null; }
            }

            input.addEventListener('focus', function() {
                stop();
                overlay.style.opacity = '0';
                input.setAttribute('placeholder', 'Search events, dates, genres...');
            });

            input.addEventListener('blur', function() {
                if (!input.value) {
                    overlay.style.opacity = '1';
                    input.setAttribute('placeholder', '');
                    start();
                }
            });

            input.addEventListener('input', function() {
                overlay.style.opacity = input.value ? '0' : '1';
            });

            start();
        }

        // Events page filter bar search (visible on load)
        initSlider(document.getElementById('search-input'), 0);

        // Header search — deferred until panel opens (panel is collapsed on load so input has 0 height)
        var headerInput = document.getElementById('site-search-input');
        var searchPanel = document.getElementById('site-search-panel');
        if (headerInput && searchPanel) {
            var headerInited = false;
            var observer = new MutationObserver(function() {
                if (!headerInited && searchPanel.classList.contains('site-search--open')) {
                    headerInited = true;
                    // Small delay to let the CSS transition expand the panel
                    setTimeout(function() {
                        initSlider(headerInput, Math.floor(Math.random() * suggestions.length));
                    }, 350);
                    observer.disconnect();
                }
            });
            observer.observe(searchPanel, { attributes: true, attributeFilter: ['class'] });
        }
    })();

    // Membership modal — open/close and basket refresh on success
    (function() {
        var modal = document.getElementById('membership-modal');
        if (!modal) return;

        var SPEKTRIX_API = 'https://tickets.chelmsfordtheatre.co.uk/chelmsfordtheatre/api/v3';

        function openModal() {
            modal.classList.add('active');
            document.body.style.overflow = 'hidden';
        }

        function closeModal() {
            modal.classList.remove('active');
            document.body.style.overflow = '';
        }

        // Open triggers
        document.querySelectorAll('.js-membership-modal-open').forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                openModal();
            });
        });

        // Close — X button
        modal.querySelectorAll('.modal-box__close').forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                closeModal();
            });
        });

        // Close — backdrop click
        modal.addEventListener('click', function(e) {
            if (e.target === modal) {
                closeModal();
            }
        });

        // Close — Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && modal.classList.contains('active')) {
                closeModal();
            }
        });

        // Watch for Spektrix success messages becoming visible, then refresh basket badge
        var successContainers = modal.querySelectorAll('[data-success-container]');
        if (successContainers.length && typeof MutationObserver !== 'undefined') {
            var observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(m) {
                    if (m.type === 'attributes' && m.attributeName === 'style') {
                        var el = m.target;
                        var visible = el.style.display !== 'none' && el.style.display !== '';
                        if (visible || window.getComputedStyle(el).display !== 'none') {
                            // Membership was added — close modal and refresh page
                            setTimeout(function() {
                                closeModal();
                                window.location.reload();
                            }, 1500);
                        }
                    }
                });
            });

            successContainers.forEach(function(el) {
                observer.observe(el, { attributes: true, attributeFilter: ['style'] });
            });
        }
    })();

    // Accordion lightbox (content block)
    (function() {
        document.querySelectorAll('.accordian-lightbox__trigger').forEach(function(trigger) {
            trigger.addEventListener('click', function() {
                var targetId = trigger.getAttribute('data-lightbox-target');
                var lightbox = document.querySelector(targetId);
                if (!lightbox) return;
                lightbox.classList.add('is-active');
                lightbox.setAttribute('aria-hidden', 'false');
                document.body.style.overflow = 'hidden';
                var closeBtn = lightbox.querySelector('.accordian-lightbox__close');
                if (closeBtn) closeBtn.focus();
            });
        });

        function closeLightbox(lightbox) {
            lightbox.classList.remove('is-active');
            lightbox.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
            var trigger = document.querySelector('[data-lightbox-target="#' + lightbox.id + '"]');
            if (trigger) trigger.focus();
        }

        document.querySelectorAll('.accordian-lightbox').forEach(function(lightbox) {
            lightbox.querySelector('.accordian-lightbox__close').addEventListener('click', function() {
                closeLightbox(lightbox);
            });
            lightbox.querySelector('.accordian-lightbox__overlay').addEventListener('click', function() {
                closeLightbox(lightbox);
            });
        });

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                var active = document.querySelector('.accordian-lightbox.is-active');
                if (active) closeLightbox(active);
            }
        });
    })();

    // Video pause/play toggle buttons
    document.querySelectorAll('.video-pause-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            var container = btn.parentElement;
            var video = container.querySelector('video') ||
                        container.parentElement.querySelector('video');
            if (!video) return;

            var icon = btn.querySelector('i');
            if (video.paused) {
                video.play();
                icon.className = 'fa-solid fa-pause';
                btn.setAttribute('aria-label', 'Pause video');
            } else {
                video.pause();
                icon.className = 'fa-solid fa-play';
                btn.setAttribute('aria-label', 'Play video');
            }
        });
    });

    // GLightbox — photo gallery lightbox
    if (typeof GLightbox !== 'undefined' && document.querySelector('.glightbox')) {
        GLightbox({ selector: '.glightbox', touchNavigation: true, loop: true });
    }
});
